import React from 'react';
import Sidebar from '../../components/Dashboard/SideBar';
import { Layout, Alert } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import userStore from '../../zustand/store/userStore';

const { Content } = Layout;

const LayoutMain = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const noSidebarRoutes = ['/login', '/signup', '/otp-verify', '/email-screen', '/quiz'];
    const noSidebar = noSidebarRoutes.includes(location.pathname);
    const { user } = userStore();

    const isUserDataIncomplete = 
        user?.role === 'student' && 
        (!user?.email || !user?.grade);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {!noSidebar && <Sidebar />}
            <Layout className="bg-[white]">
                <Content style={{ margin: noSidebar ? 0 : '20px' }}>
                    {!noSidebar && isUserDataIncomplete && (
                        <Alert
                            message="Incomplete Profile"
                            description={
                                <>
                                    Your parent email or grade is missing. Please update your profile.{' '}
                                    <span
                                        onClick={() => navigate('/profile')}
                                        style={{ color: '#1890ff', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                        Edit Profile
                                    </span>
                                </>
                            }
                            type="warning"
                            showIcon
                            style={{ marginBottom: '20px' }}
                        />
                    )}
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default LayoutMain;
